import React, { useEffect } from 'react'
import { PhysicalCard, Button, BodyText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import useTracking from '../../hooks/useTracking'
import { componentNames, fptiTypes } from '../../utils/analytics/fpti-constants'

import './login-prompt.less'

const signInUrl = '/signin/?returnUri='

function LoginPrompt() {
  const { trackClick, trackActivity } = useTracking()

  // On component mount: login prompt shown fpti
  useEffect(() => {
    trackActivity({
      name: componentNames.LOGIN_PROMPT,
      type: fptiTypes.SUCCESS,
    })
  }, [trackActivity])

  /**
   * Login button clicked
   *  - fire the login button clicked fpti
   *  - open the login prompt
   */
  const btnClickHandler = (event) => {
    event.preventDefault()
    const currentUri = event.view.document.location.href

    trackClick({
      name: componentNames.LOGIN_PROMPT,
      type: fptiTypes.ON_CLICK,
      link: 'login-prompt-btn-clicked',
    })
    window.open(`${signInUrl}${currentUri}`, '_self')
  }

  const renderLoginPrompt = () => {
    return (
      <div
        className="hc-login-prompt__container"
        data-testid="hc-login-prompt-container"
      >
        <PhysicalCard
          className="hc-login-prompt__widget"
          data-testid="hc-login-prompt-widget"
        >
          <BodyText
            className="hc-login-prompt__body-text"
            data-testid="hc-login-prompt-body-text"
          >
            <Message id="app.helpcenter.loginPrompt.label" />
          </BodyText>
          <Button
            size="sm"
            primary="true"
            aria-label="login"
            onClick={(e) => btnClickHandler(e)}
            className="hc-login-prompt__btn"
            data-testid="hc-login-prompt-btn"
          >
            <Message id="app.helpcenter.logIn.text" />
          </Button>
        </PhysicalCard>
      </div>
    )
  }

  return renderLoginPrompt()
}

export default LoginPrompt
